import { lazy } from 'react';
import { Outlet } from 'react-router-dom';

import Loadable from 'components/ui/Loadable';

const SimplePayPage = Loadable(lazy(() => import('components/pages/SimplePayPage')));
const BillPayPage = Loadable(lazy(() => import('components/pages/BillPayPage')));

const PublicRoutes = {
  path: '',
  element: <Outlet />,
  children: [
    {
      path: '/simple-pay',
      element: <SimplePayPage />
    },
    {
      path: '/billpay/:campaign/:payoff',
      element: <BillPayPage />
    },
    {
      path: '/billpay/:campaign',
      element: <BillPayPage />
    }
  ]
};

export default PublicRoutes;
